import isMobile from 'is-mobile'
import { useState } from 'react'
import { Dialog, DialogContent, DialogContentText } from '@mui/material'
import { useTranslation } from 'react-i18next'

function MobileWarningDialog () {
  const { t } = useTranslation()
  const [open, setOpen] = useState(isMobile())

  if (!open) return <></>

  return (
    <Dialog open onClose={() => setOpen(false)}>
      <DialogContent>
        <DialogContentText>
          {t('SENTENCE.MOBILE_WARNING_1')}
        </DialogContentText>
        <DialogContentText>
          {t('SENTENCE.MOBILE_WARNING_2')}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  )
}

export default MobileWarningDialog
